import { MatSortable } from '@angular/material/sort';

import { createAction, props } from '@ngrx/store';

import { CustomerError } from '../../../../definitions/enums/settings/customer-error.enum';
import { Country } from '../../../../definitions/interfaces/country/country';
import { CountryConfig } from '../../../../definitions/interfaces/country-config/country-config';
import {
  BaseCustomerConfig,
  CustomerConfig,
  InitialCustomerConfig
} from '../../../../definitions/interfaces/customer/customer-config';
import { ProformaConfig } from '../../../../definitions/interfaces/customer-overview/proforma-config.interface';

export const loadCustomersByCountryCode = createAction(
  '[Admin Panel] Load Customers By Country Code'
);

export const loadCustomersByCountryCodeSuccess = createAction(
  '[Admin Panel] Load Customers By Country Code Success',
  props<{ customers: Array<BaseCustomerConfig> }>()
);

export const changeCountryCode = createAction(
  '[Admin Panel] Change Country Code',
  props<{ countryCode: string }>()
);

export const changeTableSorting = createAction(
  '[Admin Panel] Change Table Sorting',
  props<{ sorting: MatSortable }>()
);

export const setIsLoading = createAction(
  '[Admin Panel] Set Is Loading',
  props<{ isLoading: boolean }>()
);

export const setHighlightedRows = createAction(
  '[Admin Panel] Set Highlighted Rows',
  props<{ highlightedRows: Array<number> }>()
);

export const clearHighlightedRows = createAction(
  '[Admin Panel] Clear Highlighted Rows',
);

export const deleteCustomer = createAction(
  '[Admin Panel] Delete Customer',
  props<{ customerConfigId: string }>()
);

export const deleteCustomerSuccess = createAction(
  '[Admin Panel] Delete Customer Success',
);

export const createCustomer = createAction(
  '[Admin Panel] Create New Customer',
  props<{ customer: InitialCustomerConfig }>()
);

export const updateCustomer = createAction(
  '[Admin Panel] Update Customer',
  props<{ customerConfigId: string, customer: InitialCustomerConfig }>()
);

export const addCustomerSuccess = createAction(
  '[Admin Panel] Add Customer Success',
  props<{ customer: CustomerConfig }>()
);

export const updateCustomerSuccess = createAction(
  '[Admin Panel] Update Customer Success',
  props<{ customer: CustomerConfig }>()
);

export const setCustomerError = createAction(
  '[Customer Overview] Set Customer Error',
  props<{ customerError: CustomerError }>()
);

export const resetCustomerError = createAction(
  '[Customer Overview] Reset Customer Error',
);

export const setCountriesList = createAction(
  '[Customer Overview] Set Countries List',
  props<{ countries: Array<Country> }>()
);

export const selectedCountryChange = createAction(
  '[Admin Panel] Selected Country Change',
);

export const countryConfigLoaded = createAction(
  '[Admin Panel] Country Config Loaded',
  props<{ countryConfig: CountryConfig }>()
);

export const updateProformaConfig = createAction(
  '[Admin Panel] Update Proforma Config',
  props<{ proformaConfig: ProformaConfig }>()
);

export const disableProforma = createAction(
  '[Admin Panel] Disable Proforma',
);

export const proformaConfigUpdated = createAction(
  '[Admin Panel] Proforma Config Updated',
  props<{ proformaConfig: ProformaConfig }>()
);

export const selectedCustomerChange = createAction(
  '[Admin Panel] Selected Customer Change',
  props<{ customerConfigId: string | undefined }>()
);

export const setPagination = createAction(
  '[Admin Panel] Set Pagination',
  props<{ pageIndex: number, pageSize: number }>()
);

export const resetPaginationIndex = createAction(
  '[Admin Panel] Reset Pagination Index'
);
